const data = {
  tabIndex: 0
}

export default {
  namespaced: true,
  strict: process.env.NODE_ENV === 'development',
  state () {
    return {
      ...data
    }
  },
  mutations: {
    /**
     * Set the index.
     *
     * @param {*} state
     * @param {*} index
     */
    setTabIndex (state, tabIndex) {
      state.tabIndex = tabIndex
    },

    /**
     * Reset all state.
     * @param {*} state
     */
    reset (state) {
      for (const key in state) {
        state[key] = data[key]
      }
    }
  }
}
